import ViewItems from '../../../components/ViewItems'
import { Text } from '../../../components/SecondaryMarket'

const Progress = ({ percentage, getContentKey }) => {
  
  return (
    <ViewItems className={'w-full md:w-1/2 gap-1'}>
      <Text text={`${Math.round(percentage ?? 0)}% ${getContentKey('to_complete')}`} />

      <div className='w-full h-2 rounded-full bg-grey'>
        <div className='h-2 rounded-full bg-light-blue' style={{ width: `${percentage}%` }} />
      </div>
    </ViewItems>
  )
}

export default Progress
